import { BaseService } from './base';
import { ResourceType } from '../models/resourceType';

/**
 * Minimal service for ResourceType model.
 * Inherits standard CRUD from BaseService.
 */
export class ResourceTypeService extends BaseService<ResourceType> {
  override model = ResourceType;
  override modelName = 'resourceType';
  override modelLabel = 'Resource Type';
}
